import type { HTTPService } from "@soft-db/http";
import type { Base64Query } from "./shared";

export type DynamicImageEntry = {
	from: number;
	to: number;
	name: string;
	image: string;
};

export type DynamicImage = {
	id: string;
	name: string;
	query: Base64Query;
	entries: DynamicImageEntry[];
	site: string;
};

export type DynamicImageUpdate = Omit<DynamicImage, "id" | "site">;

export class DynamicImageApi {
	constructor(private _http: HTTPService) {}

	async fetch(id: string) {
		return this._http.get<DynamicImage>(`dynamic-images/${id}`);
	}

	async fetchDynamicImages(siteId: string) {
		return this._http.get<DynamicImage[]>(`sites/${siteId}/dynamic-images`);
	}

	async create(siteId: string, dynamicImage: DynamicImageUpdate) {
		return this._http.post<DynamicImage>(`sites/${siteId}/dynamic-images`, dynamicImage);
	}

	async update(id: string, dynamicImage: DynamicImageUpdate) {
		return this._http.put<DynamicImage>(`dynamic-images/${id}`, dynamicImage);
	}

	async delete(id: string) {
		return this._http.delete(`dynamic-images/${id}`);
	}
}
